// @flow
import {
  GetContactInfoSchemaSuccess,
  GetMyDetailsSuccess,
  ToggleAbsenceDetailsModal,
  ToggleChangePasswordModal,
  ToggleContactInfoModal,
  ToggleHomePageSettingsModal,
  UpdateContactInfoSuccess,
} from "@modules/profile/constants/actions";
import type { MyDetailsState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: MyDetailsState = {
  requestsInProgress: 0,
  contactInfoSchema: null,
  data: {
    personalDetails: null,
    employmentInfo: null,
    contactInfo: null,
  },
  modals: {
    contactInfo: {
      visible: false,
    },
    homePageSettings: {
      visible: false,
    },
    changePassword: {
      visible: false,
    },
    absenceDetails: {
      visible: false,
    },
  },
  passwordSchema: {
    type: "object",
    required: ["newPasswordConfirm", "oldPassword", "newPassword"],
    properties: {
      oldPassword: {
        type: "string",
        title: "Enter Your Current Password",
      },
      newPassword: {
        type: "string",
        title: "Choose New Password",
        pattern: "((?=.*(\\d|[!@#$%^&;*()_+}{':;'?\\/.<>=]))(?=.*[a-z])(?=.*[A-Z]).{8,})",
      },
      newPasswordConfirm: {
        type: "string",
        title: "Confirm New Password",
      },
    },
    urn: "urn:jsonschema:eu:firstcare:api:v1:dto:auth:ChangePasswordDTO",
  },
};

export const setLoading = (state: MyDetailsState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetMyDetailsSuccess = (state: MyDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    data: payload,
  };
};

export const onGetContactInfoSchemaSuccess = (state: MyDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    contactInfoSchema: payload,
  };
};

export const onUpdateContactInfoSuccess = (state: MyDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    data: {
      personalDetails: { ...state.data.personalDetails },
      employmentInfo: { ...state.data.employmentInfo },
      contactInfo: {
        ...state.data.contactInfo,
        mobilePhone: payload.mobilePhone,
        homePhone: payload.homePhone,
        personalEmail: payload.personalEmail,
      },
    },
  };
};

export const onToggleAbsenceDetailsModal = (state: MyDetailsState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      absenceDetails: {
        ...state.modals.absenceDetails,
        visible: !state.modals.absenceDetails.visible,
      },
    },
  };
};

export const onToggleChangePasswordModal = (state: MyDetailsState) => () => {
  state.modals.changePassword.visible = !state.modals.changePassword.visible;
  return {
    ...state,
  };
};

export const onToggleContactInfoModal = (state: MyDetailsState) => () => {
  state.modals.contactInfo.visible = !state.modals.contactInfo.visible;
  return {
    ...state,
  };
};

export const onToggleHomePageSettings = (state: MyDetailsState) => () => {
  state.modals.homePageSettings.visible = !state.modals.homePageSettings.visible;
  return {
    ...state,
  };
};

export default (state: MyDetailsState = initialState, action: Object): MyDetailsState => {
  const act = {
    [GetMyDetailsSuccess]: onGetMyDetailsSuccess,
    [GetContactInfoSchemaSuccess]: onGetContactInfoSchemaSuccess,

    [ToggleAbsenceDetailsModal]: onToggleAbsenceDetailsModal,
    [ToggleChangePasswordModal]: onToggleChangePasswordModal,
    [ToggleContactInfoModal]: onToggleContactInfoModal,
    [ToggleHomePageSettingsModal]: onToggleHomePageSettings,
    [UpdateContactInfoSuccess]: onUpdateContactInfoSuccess,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
